"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES = void 0;
exports.default = withSpacing;
exports.propTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _responsiveProp = require("../../lib/responsiveProp");

var _parseSpacing = _interopRequireDefault(require("./parseSpacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "right-x-large": "tcl__withSpacing-614b8300",
  "top-x-large": "tcl__withSpacing-a80b3a75",
  "left-x-large": "tcl__withSpacing-cf3a3fb4",
  "bottom-x-large": "tcl__withSpacing-061f129a",
  "horizontal-x-large": "tcl__withSpacing-46786e66",
  "vertical-x-large": "tcl__withSpacing-25fd29c3",
  "all-x-large": "tcl__withSpacing-326077d5",
  "right-large": "tcl__withSpacing-cfd281b6",
  "top-large": "tcl__withSpacing-237f2a08",
  "left-large": "tcl__withSpacing-4bc6e9c5",
  "bottom-large": "tcl__withSpacing-948b1d63",
  "horizontal-large": "tcl__withSpacing-38fed268",
  "vertical-large": "tcl__withSpacing-59b96ba6",
  "all-large": "tcl__withSpacing-daf5e2cb",
  "right-medium": "tcl__withSpacing-d7a6f46a",
  "top-medium": "tcl__withSpacing-4f5fd7f6",
  "left-medium": "tcl__withSpacing-ebb8fbd7",
  "bottom-medium": "tcl__withSpacing-109b229c",
  "horizontal-medium": "tcl__withSpacing-fd25536b",
  "vertical-medium": "tcl__withSpacing-33a2a73c",
  "all-medium": "tcl__withSpacing-419750d9",
  "right-small": "tcl__withSpacing-0f7efc8c",
  "top-small": "tcl__withSpacing-f51d1e5e",
  "left-small": "tcl__withSpacing-ba7fe844",
  "bottom-small": "tcl__withSpacing-2e83e7f0",
  "horizontal-small": "tcl__withSpacing-d2a007e6",
  "vertical-small": "tcl__withSpacing-0039017a",
  "all-small": "tcl__withSpacing-7090449d",
  "right-x-small": "tcl__withSpacing-7fc3e566",
  "top-x-small": "tcl__withSpacing-ce726275",
  "left-x-small": "tcl__withSpacing-63d8275a",
  "bottom-x-small": "tcl__withSpacing-89a4bf8c",
  "horizontal-x-small": "tcl__withSpacing-d9a4175e",
  "vertical-x-small": "tcl__withSpacing-eec45447",
  "all-x-small": "tcl__withSpacing-be4e28bf",
  "tablet-right-x-large": "tcl__withSpacing-d3d621be",
  "tablet-top-x-large": "tcl__withSpacing-e2fd5c56",
  "tablet-left-x-large": "tcl__withSpacing-20f7d4cd",
  "tablet-bottom-x-large": "tcl__withSpacing-6b9fb26e",
  "tablet-horizontal-x-large": "tcl__withSpacing-f0364457",
  "tablet-vertical-x-large": "tcl__withSpacing-94baf8a8",
  "tablet-all-x-large": "tcl__withSpacing-ad1cad7d",
  "tablet-right-large": "tcl__withSpacing-7bfbb120",
  "tablet-top-large": "tcl__withSpacing-96d37696",
  "tablet-left-large": "tcl__withSpacing-ddff9d51",
  "tablet-bottom-large": "tcl__withSpacing-42efc57a",
  "tablet-horizontal-large": "tcl__withSpacing-a54d0de4",
  "tablet-vertical-large": "tcl__withSpacing-1ecee5cf",
  "tablet-all-large": "tcl__withSpacing-457829ef",
  "tablet-right-medium": "tcl__withSpacing-e4a49248",
  "tablet-top-medium": "tcl__withSpacing-5e7a18a4",
  "tablet-left-medium": "tcl__withSpacing-40926785",
  "tablet-bottom-medium": "tcl__withSpacing-84bd8c37",
  "tablet-horizontal-medium": "tcl__withSpacing-c8e35922",
  "tablet-vertical-medium": "tcl__withSpacing-88b59a0d",
  "tablet-all-medium": "tcl__withSpacing-fe071133",
  "tablet-right-small": "tcl__withSpacing-4544b1f3",
  "tablet-top-small": "tcl__withSpacing-57e0188c",
  "tablet-left-small": "tcl__withSpacing-3b49a5fe",
  "tablet-bottom-small": "tcl__withSpacing-2ca624e0",
  "tablet-horizontal-small": "tcl__withSpacing-f64bd4c0",
  "tablet-vertical-small": "tcl__withSpacing-1b2ff1cc",
  "tablet-all-small": "tcl__withSpacing-71a95082",
  "tablet-right-x-small": "tcl__withSpacing-2a4104d7",
  "tablet-top-x-small": "tcl__withSpacing-e5b6c2bc",
  "tablet-left-x-small": "tcl__withSpacing-39e5cdbc",
  "tablet-bottom-x-small": "tcl__withSpacing-0cbe5bd7",
  "tablet-horizontal-x-small": "tcl__withSpacing-bc51b3bc",
  "tablet-vertical-x-small": "tcl__withSpacing-18d30f48",
  "tablet-all-x-small": "tcl__withSpacing-c8255630",
  "desktop-right-x-large": "tcl__withSpacing-17f36797",
  "desktop-top-x-large": "tcl__withSpacing-5144a00e",
  "desktop-left-x-large": "tcl__withSpacing-47ba6cd5",
  "desktop-bottom-x-large": "tcl__withSpacing-2e8c3807",
  "desktop-horizontal-x-large": "tcl__withSpacing-58839daa",
  "desktop-vertical-x-large": "tcl__withSpacing-bc757e8c",
  "desktop-all-x-large": "tcl__withSpacing-9277306f",
  "desktop-right-large": "tcl__withSpacing-00c351f8",
  "desktop-top-large": "tcl__withSpacing-2c795ca0",
  "desktop-left-large": "tcl__withSpacing-569cfcd6",
  "desktop-bottom-large": "tcl__withSpacing-a9cd3ab4",
  "desktop-horizontal-large": "tcl__withSpacing-da0132b9",
  "desktop-vertical-large": "tcl__withSpacing-49b56040",
  "desktop-all-large": "tcl__withSpacing-7be74c8b",
  "desktop-right-medium": "tcl__withSpacing-185bbb42",
  "desktop-top-medium": "tcl__withSpacing-4569065a",
  "desktop-left-medium": "tcl__withSpacing-171b9225",
  "desktop-bottom-medium": "tcl__withSpacing-a43c96f5",
  "desktop-horizontal-medium": "tcl__withSpacing-2580f58e",
  "desktop-vertical-medium": "tcl__withSpacing-983211f8",
  "desktop-all-medium": "tcl__withSpacing-7be93fdc",
  "desktop-right-small": "tcl__withSpacing-586c3336",
  "desktop-top-small": "tcl__withSpacing-f3427e27",
  "desktop-left-small": "tcl__withSpacing-3824470e",
  "desktop-bottom-small": "tcl__withSpacing-43ba6cee",
  "desktop-horizontal-small": "tcl__withSpacing-a386c071",
  "desktop-vertical-small": "tcl__withSpacing-379e6eeb",
  "desktop-all-small": "tcl__withSpacing-aa162833",
  "desktop-right-x-small": "tcl__withSpacing-32490b6f",
  "desktop-top-x-small": "tcl__withSpacing-4baff974",
  "desktop-left-x-small": "tcl__withSpacing-6ac06ef5",
  "desktop-bottom-x-small": "tcl__withSpacing-76f62d1c",
  "desktop-horizontal-x-small": "tcl__withSpacing-fb76ecd7",
  "desktop-vertical-x-small": "tcl__withSpacing-f6b9b052",
  "desktop-all-x-small": "tcl__withSpacing-cca8fc5e"
};
const SIZES = ['x-large', 'large', 'medium', 'small', 'x-small'];
exports.SIZES = SIZES;
const propTypes = {
  /**
   * You can provide spacing clockwise like so: `spacing="small medium 0 small"`.
   *
   * Also supports shorthands similiar to css so you can provide just a single size
   * (i.e "small") to have the same spacing on every side. Similiarly if you want
   * matching vertical and horizontal spacing you can do `"large medium"` like in CSS.
   *
   * If you wish, you can can also use an array instead of a string
   * (e.g `['small', null, 'medium']`). This is useful for programatic
   * manipulation of the spacing prop.
   *
   * Use the object notation for a responsive layout (e.g. `{ mobile: 'small', tablet: 'large' }`).
   */
  spacing: _propTypes.default.oneOfType([_propTypes.default.oneOf(SIZES), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.oneOf(SIZES)), (0, _responsiveProp.responsivePropType)(_propTypes.default.oneOfType([_propTypes.default.oneOf(SIZES), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.oneOf(SIZES))]))])
};
exports.propTypes = propTypes;

function withSpacing(Component) {
  /**
   * Higher order component that provides the 'spacing' prop to a component
   * by injecting a CSS class. Look at the the [LayoutBox component](/components/LayoutBox)
   * for a more visual example of how this works.
   */
  const ComponentWithSpacing = props => {
    // eslint-disable-next-line react/prop-types
    const {
      spacing,
      className,
      ...otherProps
    } = props;
    let classes = className;
    const responsiveMap = (0, _responsiveProp.normalizeResponsiveProp)(spacing);

    for (const [breakpoint, value] of Object.entries(responsiveMap)) {
      const prefix = (0, _responsiveProp.breakpointPrefix)(breakpoint);
      const parsedSpacings = (0, _parseSpacing.default)(value, SIZES);
      classes = (0, _classnames.default)(classes, {
        [styles[`${prefix}all-${parsedSpacings.all}`]]: parsedSpacings.all,
        [styles[`${prefix}vertical-${parsedSpacings.vertical}`]]: parsedSpacings.vertical,
        [styles[`${prefix}horizontal-${parsedSpacings.horizontal}`]]: parsedSpacings.horizontal,
        [styles[`${prefix}top-${parsedSpacings.top}`]]: parsedSpacings.top,
        [styles[`${prefix}bottom-${parsedSpacings.bottom}`]]: parsedSpacings.bottom,
        [styles[`${prefix}left-${parsedSpacings.left}`]]: parsedSpacings.left,
        [styles[`${prefix}right-${parsedSpacings.right}`]]: parsedSpacings.right
      });
    }

    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      className: classes
    }, otherProps));
  };

  ComponentWithSpacing.displayName = `withSpacing(${Component.displayName || Component.name || ''})`;
  ComponentWithSpacing.propTypes = propTypes;
  return ComponentWithSpacing;
}